// extracted by mini-css-extract-plugin
export default {"notifications":"Notification_notifications__zOr1J","notification":"Notification_notification__IvU-G","success":"Notification_success__58948"};